import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import { VIEW } from '../../assets/Constants/actionsTypes';
import { useHistory, useLocation } from "react-router-dom";
import './wizard.css';
import WizardInfo from './wizardInfo'
// * We use React Slick to build the carousel 
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// * Custom Components (used inside the Slider component)
import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'
import Step4 from './Step4'
import Step5 from './Step5'
import Step6 from './Step6'
import Step7 from './Step7'
import Step8 from './Step8'
import Step9 from './Step9'
import Step10 from './Step10'
// 
import API from "../../services/api";
import Notifications, { ERROR_NOTIFICATION } from '../../helpers/notifications';

/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { BiArrowFromRight } from "react-icons/bi";

/**This component will render the entire Wizard actions. All the steps and wizard info will be render here*/
function Wizard() {
    //* To can acess the parameters sent via history.push
    const location = useLocation();
    /**Used to translate the text*/
    const { t } = useTranslation('common');
    /**We use useHistory hook to redirect */
    const history = useHistory();
    /**State used to show up the current step. Green if active, red if inactive */
    /**Step 1 by default */
    const [activeStep, setActiveStep] = useState(1);

    // * State used to enable or disable the steps inputs according to the action
    const [isEditMode, setIsEditMode] = useState(true)
    // *
    const [isModelCompleted, setIsModelCompleted] = useState(false)
    // *
    const [isActionView, setIsActionView] = useState('')

    useEffect(() => {
        setModelFlags();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const setModelFlags = async () => {
        try {
            // gets data from API
            const response = await API.get(`/model/getModelFlags?modelId=${location.state.detail.modelid}`);
            // if error in request
            if (response.data.code !== 100) {
                Notifications.notify(response.data.msg, ERROR_NOTIFICATION);
                return;
            } else {
                // * Set state according to the action
                // * If action === VIEW or the model is completed => all inputs will be disabled
                if (location.state.action === VIEW) {
                    setIsEditMode(false);
                    setIsActionView(VIEW);
                } else if (response.data.data.isReadyForAssessment) {
                    setIsEditMode(false);
                } else {
                    setIsEditMode(true);
                }
                setIsModelCompleted(response.data.data.isModelCompleted);
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e);
        }
    }

    const editSteps = async () => {
        try {
            // gets data from API
            const response = await API.get(`/model/haveScenarios?modelId=${location.state.detail.modelid}`);
            // if error in request
            if (response.data.code !== 100) {
                Notifications.notify(response.data.msg, ERROR_NOTIFICATION);
                return;
            } else {
                if (response.data.data) {
                    Notifications.notify(t('model.model_has_escenarios'), ERROR_NOTIFICATION);
                    return;
                } else {
                    // * call the api to do the upsert
                    const response = await API.post(`/model/turnOffFlags?modelId=${location.state.detail.modelid}`);

                    // * if errors exist, it is displayed as a notification
                    if (response.data.code !== 100) {
                        Notifications.notify(t(`model.${response.data.code}`), ERROR_NOTIFICATION);
                        return false;
                    }

                    setModelFlags();
                }
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e);
        }
    }

    /**Triggered when user clicks "Go Back" button. Redirects to Models view*/
    const goBack = () => {
        history.push('/Models');
    }

    /**When user clicks any arrow (previous or next) the color in the WizardInfo will be updated */
    const changeActiveStep = (stepIndex) => {
        setActiveStep(parseInt(stepIndex));
    }

    const switchSteps = () => {
        switch (activeStep) {
            case 1:
                return (
                    <Step1 activeStep={activeStep} changeStep={changeActiveStep} modelData={location.state.detail} isEditMode={isEditMode} setFlags={setModelFlags} editSteps={editSteps} isActionView={isActionView} />
                );
            case 2:
                return (
                    <Step2 activeStep={activeStep} changeStep={changeActiveStep} modelData={location.state.detail} isEditMode={isEditMode} setFlags={setModelFlags} editSteps={editSteps} isActionView={isActionView} />
                );
            case 3:
                return (
                    <Step3 activeStep={activeStep} changeStep={changeActiveStep} modelData={location.state.detail} isEditMode={isEditMode} setFlags={setModelFlags} editSteps={editSteps} isActionView={isActionView} />
                );
            case 4:
                return (
                    <Step4 activeStep={activeStep} changeStep={changeActiveStep} modelData={location.state.detail} isEditMode={isEditMode} setFlags={setModelFlags} editSteps={editSteps} isActionView={isActionView} />
                );
            case 5:
                return (
                    <Step5 activeStep={activeStep} changeStep={changeActiveStep} modelData={location.state.detail} isEditMode={isEditMode} setFlags={setModelFlags} />
                );
            case 6:
                return (
                    <Step6 activeStep={activeStep} changeStep={changeActiveStep} modelData={location.state.detail} isEditMode={location.state.action === VIEW ? false : true} setFlags={setModelFlags} />
                );
            case 7:
                return (
                    <Step9 activeStep={activeStep} changeStep={changeActiveStep} modelData={location.state.detail} isEditMode={isEditMode} setFlags={setModelFlags} isModelCompleted={isModelCompleted} isActionView={isActionView} />
                );
            case 8:
                return (
                    <Step7 activeStep={activeStep} changeStep={changeActiveStep} modelData={location.state.detail} isEditMode={isEditMode} setFlags={setModelFlags} editSteps={editSteps} isActionView={isActionView} />
                );
            case 9:
                return (
                    <Step8 activeStep={activeStep} changeStep={changeActiveStep} modelData={location.state.detail} isEditMode={isEditMode} setFlags={setModelFlags} isActionView={isActionView} />
                );
            case 10:
                return (
                    <Step10 activeStep={activeStep} changeStep={changeActiveStep} modelData={location.state.detail} isEditMode={isEditMode} setFlags={setModelFlags} isModelCompleted={isModelCompleted} />
                );
            default:
                return (
                    null
                );
        }
    }

    return (
        <>
            <div className="sub_menu">
                <div className="sub_menu_btns my-1">
                    <button className="ilo-btn wizard_goBack_btn" onClick={goBack}> <BiArrowFromRight /> {t('wizard.goBack')}</button>
                    {isModelCompleted ?
                        <>
                            <span>  |  </span>  <span style={{ color: "#960a55" }}>  {t('model.modelCalculated')}  </span>
                        </>
                        :
                        <></>
                    }
                </div>
            </div>
            <div className="container-fluid container_grid">
                <div className="row row_attrs">
                    {/* Wizard Info here */}
                    <WizardInfo activeStep={activeStep} isEditMode={isEditMode} isModelCompleted={isModelCompleted} isActionView={isActionView} />
                    {/* Steps here */}
                    <div className="col-md-10">
                        {switchSteps()}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Wizard